// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bd_bl","reviews__wrapper__list":"bd_fk","reviewSlider":"bd_fl"};